// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__tkdbH","label":"LabeledBox_label__3DxUP"};